import { render } from "./addModuleBaobeiOrder.vue?vue&type=template&id=634c7252&scoped=true"
import script from "./addModuleBaobeiOrder.vue?vue&type=script&lang=js"
export * from "./addModuleBaobeiOrder.vue?vue&type=script&lang=js"

import "./addModuleBaobeiOrder.vue?vue&type=style&index=0&id=634c7252&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-634c7252"]])

export default __exports__